import { axiosInstance } from '../axios';

import { TableResultType } from '@/shared/types/api.type';
import { MentionUserRequestType, MentionUserResponseType } from '@/shared/types/api/api.users';

export const getMentionUsers = async ({
  groupId,
}: MentionUserRequestType): Promise<TableResultType<MentionUserResponseType[]>> => {
  const { data } = await axiosInstance.get<TableResultType<MentionUserResponseType[]>>(
    `/group/${groupId}/mention-users`,
    {},
  );
  return data;
};
